<i18n src="@/locales/components/views/layout/app_header.yml" lang="yaml"></i18n>

<template>
  <TransitionRoot as="template" :show="sidebarOpen">
    <Dialog
      as="div"
      class="fixed inset-0 flex z-40"
      @close="sidebarOpen = false"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
      </TransitionChild>
      <TransitionChild
        as="template"
        enter="transition ease-in-out duration-300 transform"
        enter-from="-translate-x-full"
        enter-to="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leave-from="translate-x-0"
        leave-to="-translate-x-full"
      >
        <div
          class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white"
        >
          <TransitionChild
            as="template"
            enter="ease-in-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in-out duration-300"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <div class="absolute top-0 right-0 -mr-12 pt-2">
              <button
                type="button"
                class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              >
                <span class="sr-only">Close sidebar</span>
                <i
                  @click="sidebarOpen = false"
                  class="pt-0.5 fa-solid fa-xmark fa-xl cursor-pointer text-white"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </TransitionChild>

          <div class="flex-1 h-0 overflow-y-auto">
            <nav class="px-2 space-y-1">
              <template v-for="(user_entity_type_name, index) in user_entity_type_names" :key="index">
                <a
                  v-if="user_entity_type_names.length > 1"
                  class="bg-gray-100 text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                >
                  {{ user_entity_type_name }}
                </a>
                <template
                  v-for="user_entity_agroexporter in userEntitiesAgroExporter(user_entity_type_name)"
                  :key="user_entity_agroexporter.id"
                >
                  <template
                    v-for="rol in user_entity_agroexporter.roles"
                    :key="rol.id"
                  >
                    <template
                      v-for="permission in rol.permissions"
                      :key="permission.id"
                    >
                      <a
                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                        href="#"
                        @click.prevent="
                          goToAgroExporterRol(
                            user_entity_agroexporter.id,
                            rol.code,
                            permission.code
                          )
                        "
                      >
                        <i
                          :class="[
                            'fa-solid',
                            permission.icon,
                            'mr-4 w-5 flex-shrink-0',
                          ]"
                        />{{ permission.name }}
                      </a>
                    </template>
                  </template>
                </template>
                <template
                  v-for="user_entity_packing_house in userEntitiesPackingHouse(user_entity_type_name)"
                  :key="user_entity_packing_house.id"
                >
                  <template
                    v-for="rol in user_entity_packing_house.roles"
                    :key="rol.id"
                  >
                    <template
                      v-for="permission in rol.permissions"
                      :key="permission.id"
                    >
                      <a
                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                        href="#"
                        @click.prevent="
                          goToPackingHouseRol(
                            user_entity_packing_house.id,
                            rol.code,
                            permission.code
                          )
                        "
                      >
                        <i
                          :class="[
                            'fa-solid',
                            permission.icon,
                            'mr-4 w-5 flex-shrink-0',
                          ]"
                        />{{ permission.name }}
                      </a>
                    </template>
                  </template>
                </template>
                <template
                  v-for="user_entity_customer in userEntitiesCustomer(user_entity_type_name)"
                  :key="user_entity_customer.id"
                >
                  <template
                    v-for="rol in user_entity_customer.roles"
                    :key="rol.id"
                  >
                    <template
                      v-for="permission in rol.permissions"
                      :key="permission.id"
                    >
                      <a
                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                        href="#"
                        @click.prevent="
                          goToCustomerRol(
                            user_entity_customer.id,
                            rol.code,
                            permission.code
                          )
                        "
                      >
                        <i
                          :class="[
                            'fa-solid',
                            permission.icon,
                            'mr-4 w-5 flex-shrink-0',
                          ]"
                        />{{ permission.name }}
                      </a>
                    </template>
                  </template>
                </template>
                <template
                  v-for="user_entity_organization in userEntitiesOrganization(user_entity_type_name)"
                  :key="user_entity_organization.id"
                >
                  <template
                    v-for="rol in user_entity_organization.roles"
                    :key="rol.id"
                  >
                    <template
                      v-for="permission in rol.permissions"
                      :key="permission.id"
                    >
                      <a
                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                        href="#"
                        @click.prevent="
                          goToOrganizationRol(
                            user_entity_organization.id,
                            rol.code,
                            permission.code
                          )
                        "
                      >
                        <i
                          :class="[
                            'fa-solid',
                            permission.icon,
                            'mr-4 w-5 flex-shrink-0',
                          ]"
                        />{{ permission.name }}
                      </a>
                    </template>
                  </template>
                </template>
                <template
                  v-for="user_entity_producer in userEntitiesProducer(user_entity_type_name)"
                  :key="user_entity_producer.id"
                >
                  <template
                    v-for="rol in user_entity_producer.roles"
                    :key="rol.id"
                  >
                    <template
                      v-for="permission in rol.permissions"
                      :key="permission.id"
                    >
                      <a
                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                        href="#"
                        @click.prevent="
                          goToProducerRol(
                            user_entity_producer.id,
                            rol.code,
                            permission.code
                          )
                        "
                      >
                        <i
                          :class="[
                            'fa-solid',
                            permission.icon,
                            'mr-4 w-5 flex-shrink-0',
                          ]"
                        />{{ permission.name }}
                      </a>
                    </template>
                  </template>
                </template>
                <template
                  v-for="user_entity_service_provider in userEntitiesServiceProvider(user_entity_type_name)"
                  :key="user_entity_service_provider.id"
                >
                  <template
                    v-for="rol in user_entity_service_provider.roles"
                    :key="rol.id"
                  >
                    <template
                      v-for="permission in rol.permissions"
                      :key="permission.id"
                    >
                      <a
                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                        href="#"
                        @click.prevent="
                          goToServiceProviderRol(
                            user_entity_service_provider.id,
                            rol.code,
                            permission.code
                          )
                        "
                      >
                        <i
                          :class="[
                            'fa-solid',
                            permission.icon,
                            'mr-4 w-5 flex-shrink-0',
                          ]"
                        />{{ permission.name }}
                      </a>
                    </template>
                  </template>
                </template>
              </template>
            </nav>
          </div>
        </div>
      </TransitionChild>
      <div class="flex-shrink-0 w-14" aria-hidden="true">
        <!-- Dummy element to force sidebar to shrink to fit close icon -->
      </div>
    </Dialog>
  </TransitionRoot>

  <div class="flex flex-col flex-1">
    <div class="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow mb-6">
      <button
        type="button"
        class="px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-lime-500"
        @click="sidebarOpen = true"
      >
        <span class="sr-only">Open sidebar</span>
        <i class="fa-solid fa-bars h-6 w-6"></i>
      </button>
      <div class="flex-1 px-4 flex justify-between">
        <div class="flex-1 flex">
          <img
            :src="clientLogo()"
            :alt="clientCode()"
            class="py-2"
            @click.prevent="goToDashboard()"
            @error="clientLogoError"
          />
        </div>

        <div class="ml-4 flex items-center md:ml-6">
          <!-- Profile dropdown -->
          <Menu as="div" class="ml-3 relative">
            <div>
              <MenuButton
                class="max-w-xs rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500 lg:p-2 lg:rounded-md lg:hover:bg-gray-50"
              >
                <span class="hidden ml-3 text-sm font-medium lg:block"
                  ><span class="sr-only">Open user menu for </span
                  >{{ getUserFullName() }}</span
                >
                <i
                  class="fa-solid fa-chevron-down hidden flex-shrink-0 pt-1 ml-1 h-5 w-5 lg:block"
                  aria-hidden="true"
                ></i>
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <MenuItem v-slot="{ active }">
                  <router-link
                    :to="{ name: 'up_change_data_edit_password_path' }"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-gray-700',
                    ]"
                    >{{ $t("labels.edit_password") }}</router-link
                  >
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <router-link
                    :to="{ name: 'logout_path' }"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-gray-700',
                    ]"
                    >{{ $t("labels.close_sesion") }}</router-link
                  >
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import {
  Dialog,
  DialogOverlay,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  components: {
    Dialog,
    DialogOverlay,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
  },
  methods: {
    goToDashboard: function () {
      this.$router.push({
        name: "home_path",
      });
    },
    goToAgroExporterRol: function (
      agro_exporter_id,
      rol_code,
      permission_code
    ) {
      this.sidebarOpen = false;
      this.$router.push({
        name: this.routeName("", `ae_${rol_code}_${permission_code}`),
        params: {
          agro_exporter_id: agro_exporter_id,
        },
      });
    },
    goToPackingHouseRol: function (
      packing_house_id,
      rol_code,
      permission_code
    ) {
      this.sidebarOpen = false;
      this.$router.push({
        name: `ph_${rol_code}_${permission_code}_list_processes_path`,
        params: {
          packing_house_id: packing_house_id,
        },
      });
    },
    goToCustomerRol: function (customer_id, rol_code, permission_code) {
      this.sidebarOpen = false;
      this.$router.push({
        name: `customer_${rol_code}_${permission_code}_list_agro_exporters_path`,
        params: {
          customer_id: customer_id,
        },
      });
    },
    goToOrganizationRol: function (organization_id, rol_code, permission_code) {
      this.sidebarOpen = false;
      this.$router.push({
        name: this.routeName("", `org_${rol_code}_${permission_code}`),
        params: {
          organization_id: organization_id,
        },
      });
    },
    goToProducerRol: function (producer_id, rol_code, permission_code) {
      this.sidebarOpen = false;
      this.$router.push({
        name: this.routeName("", `prod_${rol_code}_${permission_code}`),
        params: {
          producer_id: producer_id,
        },
      });
    },
    goToServiceProviderRol: function (
      service_provider_id,
      rol_code,
      permission_code
    ) {
      this.sidebarOpen = false;
      this.$router.push({
        name: this.routeName("", `sp_${rol_code}_${permission_code}`),
        params: {
          service_provider_id: service_provider_id,
        },
      });
    },
    getUserFullName: function () {
      return this.$store.getters["user/getFullName"];
    },
  },
  setup() {
    const sidebarOpen = ref(false);

    return {
      sidebarOpen,
    };
  },
};
</script>
